import {
    AlertDialog,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "@component/alert-dialog";
import { Button } from "@component/button";
import { Checkbox } from "@component/checkbox";
import { AlertTriangle } from "lucide-react";
import { useState } from "react";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onGenerate: () => void;
}

export default function ConfirmGenerateInterviewDialog(props: Props) {
    const [dontShowAgain, setDontShowAgain] = useState(false);

    const handleGenerate = () => {
        if (dontShowAgain) {
            localStorage.setItem("hideGenerateInterviewWarning", "true");
        }
        props.onGenerate();
        props.onClose();
    }

    return (
        <AlertDialog open={props.isOpen} onOpenChange={props.onClose}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle className="flex items-center gap-2">
                        <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
                            <AlertTriangle className="w-5 h-5 text-amber-600" />
                        </div>
                        Overwrite Existing Sections?
                    </AlertDialogTitle>
                    <AlertDialogDescription className="text-base">
                        Generating new interview sections will overwrite your existing
                        sections and questions.
                        <br />
                        <br />
                        This action cannot be undone.
                    </AlertDialogDescription>
                </AlertDialogHeader>

                <div
                    className="px-6 pb-2"
                    style={{
                        paddingRight: "0px",
                        paddingBottom: "0px",
                        paddingLeft: "0px",
                    }}
                >
                    <div className="flex items-center space-x-2">
                        <Checkbox
                            id="dont-show-again"
                            checked={dontShowAgain}
                            onCheckedChange={(checked) =>
                                setDontShowAgain(checked === true)
                            }
                        />

                        <label
                            htmlFor="dont-show-again"
                            className="text-base text-muted-foreground cursor-pointer"
                        >
                            Don't show this message again
                        </label>
                    </div>
                </div>

                <AlertDialogFooter>
                    <Button variant="outline" onClick={props.onClose}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleGenerate}
                        className="bg-blue-600 hover:bg-blue-700 text-white"
                    >
                        Continue
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}